import React, { Fragment, useState } from 'react'
import { useLocation, useNavigate } from 'react-router'

import { AnalyticsEvent } from 'utils/analytics'
import Box from '@mui/material/Box'
import { ClientGalleryUploadFloatingToolBar } from 'components/pages/Gallery/_main/ClientGallery/ClientGalleryFloatingToolBar'
import { ClientPropertySelfUploadPopup } from '../ClientPropertySelfUploadPopup/ClientPropertySelfUploadPopup.module'
import { EmptyContent } from 'components/common/EmptyContent'
import FilterRoundedIcon from '@mui/icons-material/FilterRounded'
import { GRAY_800 } from 'constants/styling/theme'
import { MUIButton } from 'components/common/MUIButton'
import { Path } from 'constants/router'
import { ToolbarMode } from 'components/pages/Gallery/_main/ClientGallery/_main'
import { VisualFileType } from 'constants/visual'
import { navigateWithSearchHash } from 'utils/helpers'
import { useClientProperty } from '../_main/contexts'
import { useTranslation } from 'react-i18next'

/**
 * Client Property Empty Visuals Gallery.
 *
 * @example <ClientPropertyEmptyVisualsGallery />
 */
export const ClientPropertyEmptyVisualsGallery: React.FC = () => {
  const { t } = useTranslation(['gallery', 'ai_editing_empty_content'])
  const navigate = useNavigate()
  const location = useLocation()

  const { propertyId, handleClickOnEmptyAction } = useClientProperty()

  const [isUploadPopupOpened, setIsUploadPopupOpened] = useState(false)

  return (
    <Fragment>

      <Box maxWidth="60rem" width="100%" margin="auto" marginTop="8rem">
        <EmptyContent
          title={t('client_gallery.no_assignment_visual')}
          icon={<FilterRoundedIcon sx={{ color: GRAY_800, fontSize: '2.8rem' }} />}
          button={
            <MUIButton
              sx={{ marginTop: '2.4rem' }}
              onClick={() => {
                handleClickOnEmptyAction(AnalyticsEvent.PROPERTY_ORDER_VISUALS_CLICKED)
                navigate({ pathname: Path.PURCHASE_FLOW, search: `?realtyId=${propertyId}` },
                  { state: { redirectedFrom: navigateWithSearchHash(location) } }
                )
              }}
            >
              {t('client_gallery.no_assignment_visual_action')}
            </MUIButton>
          }
        />
      </Box>

      <ClientGalleryUploadFloatingToolBar
        mode={ToolbarMode.UPLOAD_VISUALS}
        isDownload={false}
        isToolBarOpen={true}
        setIsUploadPopupOpened={setIsUploadPopupOpened}
      />

      <ClientPropertySelfUploadPopup
        isUploadPopupOpened={isUploadPopupOpened}
        setIsUploadPopupOpened={setIsUploadPopupOpened}
        normalizedOriginalType={VisualFileType.POST}
      />

    </Fragment>
  )
}
